<div #topLevel id="topLevel">
  <!-- <ngx-spinner></ngx-spinner> -->
  <div #body id="body">
    <app-sidebar *ngIf="isLoggedIn$"></app-sidebar>
    <router-outlet></router-outlet>
  </div>
</div>
<div id="rotate-message">This application is best viewed in portrait mode.</div>
